module.exports = __webpack_public_path__ + "src/assets/img/share/739abff25378f7847df2c3756c3cb839.png";